// extracted by mini-css-extract-plugin
module.exports = {"title":"Body_title__9JORW"};